<template>
      <v-col>
          <v-card :loading="courseLoadStatus===1 || childrenLoadStatus===1">
            <v-toolbar dense flat>
              <v-btn :to="{ name: 'slowniki.grupy' }" small color="primary">
                <v-icon>mdi-arrow-left</v-icon>
                Powrót do listy
              </v-btn>
              <v-spacer></v-spacer>
              <v-toolbar-title><strong>Grupa - {{ courseItem.name }}</strong></v-toolbar-title>
            </v-toolbar>

          <v-row>
            <v-col class="col-6 pl-5">
              <v-card flat class="elevation-1">
                <v-data-table
                  :headers="headersUsers"
                  :items="tableUsers"
                  sort-by="lp"
                  class="elevation-0"
                  dense
                  hide-default-footer
                  disable-pagination
                  style="background-color: #f4f4f4;"
                >
                  <template v-slot:top>
                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                      <v-toolbar-title>Nauczyciele</v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-select
                        v-if="user.permissions['dictionary'] >= 10"
                        v-model="selectedUser"
                        class="search"
                        :items="availableUsers"
                        label="Wybierz nauczyciela"
                        hide-details
                        dense
                      ></v-select>
                      <v-divider v-if="user.permissions['dictionary'] >= 10" class="mx-4" inset vertical></v-divider>
                      <v-btn
                        v-if="user.permissions['dictionary'] >= 10"
                        :disabled="selectedUser==0"
                        @click="addUser"
                        x-small
                        class="mb-2 mt-2"
                        color="primary"
                      >
                        dodaj
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.lp="{ item }">
                   <span :class="item.status?'':'deleted'">{{item.lp}}</span>
                  </template>
                  <template v-slot:item.name="{ item }">
                   <span :class="item.status?'':'deleted'">{{item.name}} {{item.surname}}</span>
                   <v-icon
                        v-if="item.pivot.temp"
                        size="18"
                        class="ml-1 mb-1"
                      >
                        mdi-timer-outline
                      </v-icon>
                  </template>
                  <template v-slot:item.mobile="{ item }">
                   <span :class="item.status?'':'deleted'">{{item.mobile}}</span>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-tooltip v-if="user.permissions['dictionary'] >= 10" right>
                      <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        size="18"
                        class="mr-2"
                        @click="deleteUser(item)"
                      >
                        mdi-delete
                      </v-icon>
                      </template>
                      <span>Usuń</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
         
        </v-row>

        <v-row>
          <v-col class="col-5 pl-5">
            <v-card flat class="elevation-1">
              <v-data-table
                :headers="headersChildren"
                :items="tableChildren"
                
                :search="searchChild"
                class="elevation-0"
                item-key="id"
                :show-select="user.permissions['dictionary'] >= 10"
                v-model="selectedFromGroup"
                dense
                hide-default-footer
                disable-pagination
                style="background-color: #f4f4f4;"
              >

                <template v-slot:item.lp="{ item }">
                   <span :class="item.status?'':'deleted'">{{item.lp}}</span>
                  </template>
                  <template v-slot:item.name="{ item }">
                   <span :class="item.status?'':'deleted'">{{item.name}}</span>
                  </template>
                  <template v-slot:item.surname="{ item }">
                   <span :class="item.status?'':'deleted'">{{item.surname}}</span>
                  </template>
                  <template v-slot:item.birth_year="{ item }">
                   <span :class="item.status?'':'deleted'">{{item.birth_year}}</span>
                  </template>

                <template v-slot:top>
                  <v-toolbar flat style="background-color: #f4f4f4;" dense>
                    <v-toolbar-title
                      >Dzieci w grupie
                      <v-chip class="ma-2" color="primary" small
                        ><strong>{{ tableChildren ? tableChildren.length : '' }}</strong></v-chip
                      >
                    </v-toolbar-title>

                    <v-menu
                      v-if="selectedFromGroup.length>0"
                      v-model="qrcodeMenu"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                            size="28"
                            class="ml-2"
                          >
                            mdi-printer
                          </v-icon>
                      </template>

                      <v-card width="250">
                              <v-select
                                v-model="qrcodeQty"
                                class="ml-5 mr-5"
                                :items="[
                                          { text: '8 kart na stronę', value: 8 },
                                          { text: '10 kart na stronę', value: 10 },
                                        ]"
                                single-line
                              ></v-select>
                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn text @click="qrcodeMenu = false">Anuluj</v-btn>
                          <v-btn color="primary" text @click="printFile">Pobierz</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>

                    <v-spacer></v-spacer>

                    <v-text-field
                      v-model="searchChild"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                    ></v-text-field>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-card>
          </v-col>

          <v-col class="col-2">
            <v-row
              align="center"
              justify="center"
              class="fill-height flex-column"
            >
              <v-btn
                :disabled="selectedFromAll.length < 1"
                @click="addChildrenToGroup"
                depressed
                color="success"
                class="mt-5 mb-5"
                ><v-icon left dark>mdi-arrow-left-bold-outline</v-icon
                >Dodaj</v-btn
              >

              <v-btn
                :disabled="selectedFromGroup.length < 1"
                @click="deleteChildrenFromGroup"
                depressed
                color="warning"
                class="mt-5 mb-5"
                >Usuń<v-icon right dark
                  >mdi-arrow-right-bold-outline</v-icon
                ></v-btn
              >
            </v-row>
          </v-col>
          <v-col class="col-5">
            <v-card flat class="elevation-1">
              <v-data-table
                :key="componentKey"
                :headers="headers"
                :items="tableItems"
                :options.sync="tableOptions"
                :server-items-length="options.lineCount"
                class="elevation-0"
                item-key="id"
                :show-select="user.permissions['dictionary'] >= 10"
                v-model="selectedFromAll"
                dense
                hide-default-footer
                disable-pagination
                must-sort
                style="background-color: #f4f4f4;"
              >

                <template v-slot:item.course="{ item }">
                  <span v-if="item.courses" :class="item.courses.status?'':'deleted'">{{item.courses.name}}</span>
                </template>

                <template v-slot:top>
                  <v-toolbar flat style="background-color: #f4f4f4;" dense>
                    <v-toolbar-title>Lista dzieci </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-checkbox
                      v-model="showWithoutCourse"
                      class="mt-4 pt-2"
                      label="Bez grupy"
                    ></v-checkbox>

                    <v-spacer></v-spacer>

                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          v-model="searchChildAll"
                          append-icon="mdi-magnify"
                          label="Wyszukaj"
                          single-line
                          hide-details
                          class="search"
                          @keydown.enter="searchChildren"
                      ></v-text-field>
                      </template>
                        <span>Wpisz min 3 znaki i naciśnij Enter</span>
                    </v-tooltip>

                  
                  </v-toolbar>
                </template>
              </v-data-table>
              <div style="background-color: #f4f4f4;" class="text-center pt-2">
                <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && childrenLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
                <v-btn @click="loadChildren" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
                <v-btn @click="loadChildren" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
              
              </div>
            </v-card>
          </v-col>
        </v-row>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
</template>

<script>
  import confirm from '../components/Confirm'
  import qrcode from '../components/QRCode'; 
  import {jsPDF} from 'jspdf'
  import logusLogo from '../plugins/jspdf_resources'

  export default {
    components:{
      confirm
    },
    data: () => ({
      menuOd: false,
      menuDo: false,
      componentKey:0,
      tableOptions: {},
      searchChildAll:'',
      //selectedYear:0,
      dialog: false,
      itemEditing:false,
      searchChild:'',
      itemWasDefault:false,
      qrcodeMenu:false,
      qrcodeQty:8,
      headersUsers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
        { text: "Nauczyciel", value: "name" },
        { text: "Telefon", value: "mobile" },
        { text: "Akcje", value: "actions", sortable: false },
      ],
      headersChildren: [
      { text: "", align: "start", sortable: false, value: "lp",filterable:false },
      { text: "Imię", value: "name" },
      { text: "Nazwisko", value: "surname" },
      { text: "Rocznik", value: "birth_year" },
      { text: '',value:'data-table-sort',sortable: false}
      ],
      headers: [
      { text: "", align: "start", sortable: false, value: "lp",filterable:false },
      { text: "Imię", value: "name",filterable:true },
      { text: "Nazwisko", value: "surname",filterable:true },
      { text: "Rocznik", value: "birth_year",filterable:true },
      { text: "Grupa", value: "course" },
    ],
      selectedUser:0,
      selectedFromGroup: [],
      selectedFromAll: [],
    }),
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getChildOptionsInCourse;
        },
        set (value) {
          //this.searchChildAll='';
          this.$store.dispatch( 'setChildOptionsInCourse', {options:value} )
        }
      },
     
      showWithoutCourse: {
        get () {
          return this.$store.getters.getChildOptionsInCourse.showWithoutCourse;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showWithoutCourse = value;
          this.options = currentOptions;
        }
      },
      courseItem(){
        return this.$store.getters.getCourse;
      },
      tableUsers(){
        return this.$store.getters.getCourse.users;
      },
      tableChildren(){
        return this.$store.getters.getCourse.children;
      },
      courseLoadStatus(){
        return this.$store.getters.getCourseLoadStatus;
      },
      availableUsers(){
        return this.$store.getters.getLookups.users.filter(u => !_.find(this.tableUsers,{'id':u.value}));
      },
      tableItems(){
        return this.$store.getters.getChildren;
      },
      childrenLoadStatus(){
        return this.$store.getters.getChildrenLoadStatus;
      },

     
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadCourse();
        this.loadChildren();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadCourse();
          this.loadChildren();
        }, 2000)
      }
    },
    methods: {
      loadCourse(){
        this.$store.dispatch( 'loadCourse', {slug:  this.$route.params.id} );
      },
      addUser(){
        this.$store.dispatch( 'addUserToCourse', {slug: this.courseItem.id ,id:  this.selectedUser} );
        this.selectedUser = 0;
      },
      loadChildren(){
        this.searchChildAll='';

        var currentOptions = {...this.options};
        currentOptions.showWithoutCourse = true;
        //currentOptions.showDeleted = true;
        currentOptions.selectedYear = this.$route.params.year_id;
        currentOptions.selectedCourse = this.$route.params.id;
        this.options = currentOptions;
        //this.showWithoutCourse = true;
        //this.$store.dispatch( 'loadChildren' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreChildrenInCourse' );
      },
      deleteChildrenFromGroup(){
        this.$store.dispatch( 'deleteChildrenFromCourse',{slug:this.$route.params.id,ids:_.map(this.selectedFromGroup,'id')});
        this.selectedFromGroup = [];
      },
      addChildrenToGroup(){
        if(_.filter(this.selectedFromAll,function(o) { return o.courses;}).length){
          this.$refs.confirm.open('Potwierdź', 'Niektóre dzieci zostaną przeniesione z innej grupy, potwierdź wybór.', { color: 'warning' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'addChildrenToCourse',{slug:this.$route.params.id,ids:_.map(this.selectedFromAll,'id')});
              this.selectedFromAll = [];
            }
          })
        }else{
          this.$store.dispatch( 'addChildrenToCourse',{slug:this.$route.params.id,ids:_.map(this.selectedFromAll,'id')});
          this.selectedFromAll = [];
        }
     },
      deleteUser(item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunąć nauczyciela?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteUserFromCourse', {slug: this.courseItem.id ,id:  item.id});
            }
        })
      },
   
      searchChildren(){
        if(this.searchChildAll.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'value'),';');
          this.$store.dispatch( 'searchChildrenInCourse',{filterableHeaders:filterableHeaders,q:this.searchChildAll.replace(/,/, ".")});
        }
      },
      printFile(){
        var doc = this.qrcodeQty==8?this.generatePDF8():this.generatePDF10();
        doc.save(this.courseItem.name+'.pdf');
        //doc.autoPrint();
        //doc.output('dataurlnewwindow');
      },    
      generatePDF8(){
        var QRCode = require('qrcode')
        var doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        })
        var xStart = 5;
        var yStart = 5;
        for (let i = 1; i <= this.selectedFromGroup.length; i++) {
          doc.roundedRect(xStart,yStart,54,86,2,2);
          doc.addImage(logusLogo, 'PNG', xStart + 20, yStart + 2, 14.4, 12.8);
          var codeData = '';
          QRCode.toDataURL(JSON.stringify({ logus: this.selectedFromGroup[i-1].code }),{ width: 200, margin:0, quality:1 }, function (err, url) {
            codeData = url;
          })
          doc.addImage(codeData, 'PNG', xStart + 7, yStart +36, 40, 40);
          doc.setFont("Roboto-Medium", "bold");
          doc.setFontSize(15);
          doc.text(this.selectedFromGroup[i-1].name, xStart + 27, yStart + 24, {align:'center'});
          doc.setFont("Roboto-Regular", "normal");
          doc.text(this.selectedFromGroup[i-1].surname, xStart + 27, yStart + 32, {align:'center'});
          doc.setFontSize(12);
          doc.text(this.courseItem.name, xStart + 27, yStart + 82, {align:'center'});
          xStart = xStart + 74 + 4
          if(i%8==0){//nowa strona
            doc.addPage('a4','landscape');
            xStart = 5;
            yStart = 5;
          }else if(i%4==0){//druga linia
            xStart = 5;
            yStart+= 108 + 5;
          }
        }

        return doc;
      },
      generatePDF10(){
        var QRCode = require('qrcode')
        var doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        })
        var xStart = 5;
        var yStart = 5;
        for (let i = 1; i <= this.selectedFromGroup.length; i++) {
          doc.roundedRect(xStart,yStart,54,86,2,2);
          doc.addImage(logusLogo, 'PNG', xStart + 20, yStart + 2, 14.4, 12.8);
          var codeData = '';
          QRCode.toDataURL(JSON.stringify({ logus: this.selectedFromGroup[i-1].code }),{ width: 200, margin:0, quality:1 }, function (err, url) {
            codeData = url;
          })
          doc.addImage(codeData, 'PNG', xStart + 7, yStart +36, 40, 40);
          doc.setFont("Roboto-Medium", "bold");
          doc.setFontSize(15);
          doc.text(this.selectedFromGroup[i-1].name, xStart + 27, yStart + 24, {align:'center'});
          doc.setFont("Roboto-Regular", "normal");
          doc.text(this.selectedFromGroup[i-1].surname, xStart + 27, yStart + 32, {align:'center'});
          doc.setFontSize(12);
          doc.text(this.courseItem.name, xStart + 26, yStart + 82, {align:'center'});
          xStart = xStart + 54 + 4
          if(i%10==0){//nowa strona
            doc.addPage('a4','landscape');
            xStart = 5;
            yStart = 5;
          }else if(i%5==0){//druga linia
            xStart = 5;
            yStart+= 108 + 5;
          }
        }

        return doc;
      },
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}
</style>